import type { CSSProperties, FC } from 'react';
import { cx } from '@linaria/atomic';
import { Label } from '../atoms/label.component';
import { FloatingLabelStyles } from './floating-label.styles';
import { FloatingLabelProps } from './types';

export const FloatingLabel: FC<React.PropsWithChildren<FloatingLabelProps>> = ({
  active,
  children,
  className,
  disabled,
  hasError,
  leftOffset = 0,
  style,
  ...rest
}) => {
  const labelClassName = FloatingLabelStyles.floatingLabel({ disabled, hasError, leftOffset, active });
  const labelStyle: CSSProperties | undefined =
    leftOffset && !active ? ({ ...style, '--floating-label-left-offset': `${leftOffset}px` } as CSSProperties) : style;

  return (
    <Label className={cx(labelClassName, className)} style={labelStyle} {...rest}>
      {children}
    </Label>
  );
};
